import {
  apiUrlWithParams,
  applicationUrl,
  uiPathWithParams,
  urlWithParams,
} from "./ApplicationUrl";
import { asAbsoluteApiUrl } from "./functions";
import { IdType } from "../Utils/IdType";

// COUNTRIES
export const countryUrls = {
  base: applicationUrl({ relativeUrl: "Countries" }),
};

// CARRIERs
const CARRIER_URL = "Carriers";

export const carrierUrls = {
  base: applicationUrl({ relativeUrl: `/${CARRIER_URL}` }),
  addCarrier: applicationUrl({
    relativeUrl: `/${CARRIER_URL}/Add`,
    relativeApiUrl: `/${CARRIER_URL}`,
  }),
  carrierWithId: urlWithParams(
    (carrierId: number | string | undefined) => `${CARRIER_URL}/${carrierId}`
  ),
};

const BRANCHES_URL = "Branches";

export const branchUrls = {
  branchWithId: apiUrlWithParams((branchId: number | undefined) => `/${BRANCHES_URL}/${branchId}`),
  branchesForCarrierWithId: apiUrlWithParams(
    (carrierId: number | string | undefined) => `${CARRIER_URL}/${carrierId}/${BRANCHES_URL}`
  ),
  selectableGsdbs: asAbsoluteApiUrl(`${BRANCHES_URL}/GsdbSelectionList`),
};

// CONTACTs
const CONTACT_URL = "Contacts";

export const contactUrls = {
  base: applicationUrl({ relativeUrl: `/${CONTACT_URL}` }),
  addContact: applicationUrl({
    relativeUrl: `${CONTACT_URL}/Add`,
    relativeApiUrl: `${CONTACT_URL}`,
  }),
  contactWithId: urlWithParams(
    (contactId: number | string | undefined) => `${CONTACT_URL}/${contactId}`
  ),
  upload: asAbsoluteApiUrl(`/${CONTACT_URL}/Upload`),
};

// EQUIPMENT
export const equipmentUrls = {
  base: applicationUrl({
    relativeUrl: "Equipment",
  }),
};

// LOCATIONS
// EDCs
const EDC_URL = "EDCs";
export const edcUrls = {
  addEdc: applicationUrl({
    relativeUrl: `${EDC_URL}/Add`,
    relativeApiUrl: `${EDC_URL}`,
  }),
  mutateEdc: urlWithParams((id: number | string | undefined) => `${EDC_URL}/${id}`),
  base: applicationUrl({
    relativeUrl: EDC_URL,
  }),
  selectableEdc: applicationUrl({
    relativeUrl: `${EDC_URL}/SelectionList`,
  }),
  selectableGsdbs: asAbsoluteApiUrl(`${EDC_URL}/GsdbSelectionList`),
};

// ODCs
const ODC_URL = "ODCs";
export const odcUrls = {
  base: applicationUrl({
    relativeUrl: ODC_URL,
  }),
  addOdc: applicationUrl({
    relativeUrl: `/${ODC_URL}/Add`,
    relativeApiUrl: `/${ODC_URL}`,
  }),
  updateOdc: applicationUrl({ relativeUrl: `/${ODC_URL}` }),
  editOdc: urlWithParams((odcId: number | string | undefined) => `${ODC_URL}/${odcId}`),
  deleteOdc: urlWithParams((odcId: number | string | undefined) => `${ODC_URL}/${odcId}`),
  selectableGsdbs: asAbsoluteApiUrl(`${ODC_URL}/GsdbSelectionList`),
  selectableOdcGsdbs: asAbsoluteApiUrl(`${ODC_URL}/ODC/GsdbSelectionList`),
  selectableEpcGsdbs: asAbsoluteApiUrl(`${ODC_URL}/EPC/GsdbSelectionList`),
};

// PLANTs
const PLANT_URL = "Plants";
export const plantUrls = {
  base: applicationUrl({
    relativeUrl: PLANT_URL,
  }),
  addPlant: applicationUrl({
    relativeUrl: `/${PLANT_URL}/Add`,
    relativeApiUrl: `/${PLANT_URL}`,
  }),
  plantWithId: urlWithParams(
    (plantId: number | string | undefined | null) => `${PLANT_URL}/${plantId}`
  ),
  selectableGsdbs: applicationUrl({
    relativeUrl: `${PLANT_URL}/GsdbSelectionList`,
  }),
  selectableGsdbsNew: applicationUrl({
    relativeUrl: `${PLANT_URL}/GsdbSelectionItemsBySearchValue`,
  }),
  initialSelectableGsdbs: applicationUrl({
    relativeUrl: `${PLANT_URL}/InitialGsdbSelectionItems`,
  }),
};

// PLANT DOCKs

const DOCK_URL = "Docks";
export const plantDockUrls = {
  dockWithId: apiUrlWithParams((dockId: number | undefined) => `/${DOCK_URL}/${dockId}`),
  docksForPlantWithId: apiUrlWithParams(
    (plantId: number | string | undefined) => `/${PLANT_URL}/${plantId}/${DOCK_URL}`
  ),
};

// SUPPLIERs
const SUPPLIER_URL = "Suppliers";
export const supplierUrls = {
  base: applicationUrl({
    relativeUrl: SUPPLIER_URL,
  }),
  addSupplier: applicationUrl({
    relativeUrl: `${SUPPLIER_URL}/Add`,
    relativeApiUrl: `${SUPPLIER_URL}`,
  }),
  updateSupplier: applicationUrl({ relativeUrl: `${SUPPLIER_URL}` }),
  supplierWithId: urlWithParams(
    (supplierId: number | string | undefined) => `${SUPPLIER_URL}/${supplierId}`
  ),
  selectableGsdbs: applicationUrl({
    relativeUrl: `${SUPPLIER_URL}/GsdbSelectionList`,
  }),
  // ToDo: Rename and Remove url above
  selectableGsdbsNew: applicationUrl({
    relativeUrl: `${SUPPLIER_URL}/GsdbSelectionItemsBySearchValue`,
  }),
  // ToDo: DEV - WIP
  initialSelectableGsdbs: applicationUrl({
    relativeUrl: `${SUPPLIER_URL}/InitialGsdbSelectionItems`,
  }),
};

// OpeningTimes
const OPENINGTIMES_URL = "OpeningTimes";

export const openingTimesUrls = {
  openingTimeWithId: apiUrlWithParams(
    (openingTimeId: IdType) => `/${OPENINGTIMES_URL}/${openingTimeId}`
  ),
  openingTimesForSupplierWithId: apiUrlWithParams(
    (supplierId: IdType) => `${SUPPLIER_URL}/${supplierId}/${OPENINGTIMES_URL}`
  ),
  openingTimesForPlantsWithId: apiUrlWithParams(
    (plantId: IdType) => `${PLANT_URL}/${plantId}/${OPENINGTIMES_URL}`
  ),
  openingTimesForODCsWithId: apiUrlWithParams(
    (odcId: IdType) => `${ODC_URL}/${odcId}/${OPENINGTIMES_URL}`
  ),
  openingTimesForEDCsWithId: apiUrlWithParams(
    (edcId: IdType) => `${EDC_URL}/${edcId}/${OPENINGTIMES_URL}`
  ),
};

// VALIDATION BACKLOG
const VALIDATION_BACKLOG_URL = "PDSRs";
export const validationBacklogUrls = {
  pdsrs: applicationUrl({
    relativeUrl: VALIDATION_BACKLOG_URL,
    relativeApiUrl: "/PDSRValidationItems",
  }),
};

// STATIC NETWORK
const STATIC_NETWORK_URL = "StaticNetwork";
// BID PACKs
const BID_PACK_URL = "BidPacks";
const BID_PACK_URL_COMBINED = `${STATIC_NETWORK_URL}/${BID_PACK_URL}`;
export const bidPackUrls = {
  base: applicationUrl({
    relativeUrl: BID_PACK_URL,
    relativeApiUrl: `/${BID_PACK_URL_COMBINED}`,
  }),
  addBidPack: applicationUrl({
    relativeUrl: `${BID_PACK_URL}/Add`,
  }),
  uiPathForBidPackWithId: uiPathWithParams(
    (bidPackId: number | string | undefined) => `${BID_PACK_URL}/${bidPackId}`
  ),
  apiUrlForBidPackWithId: apiUrlWithParams(
    (bidPackId: number | string | undefined) => `${BID_PACK_URL_COMBINED}/${bidPackId}`
  ),
};

// RATE AGREEMENTs
const RATE_AGREEMENT_URL = "RateAgreements";
const RATE_AGREEMENT_URL_COMBINED = `${STATIC_NETWORK_URL}/${RATE_AGREEMENT_URL}`;
export const rateAgreementUrls = {
  base: applicationUrl({
    relativeUrl: RATE_AGREEMENT_URL,
    relativeApiUrl: `${RATE_AGREEMENT_URL_COMBINED}`,
  }),
  addRateAgreement: applicationUrl({
    relativeUrl: `${RATE_AGREEMENT_URL}/Add`,
  }),
  uiPathForRateAgreementWithId: uiPathWithParams(
    (rateAgreementId: number | string | undefined) => `${RATE_AGREEMENT_URL}/${rateAgreementId}`
  ),
  apiUrlForRateAgreementWithId: apiUrlWithParams(
    (rateAgreementId: number | string | undefined) =>
      `${RATE_AGREEMENT_URL_COMBINED}/${rateAgreementId}`
  ),
  availableBidPacksForRateAgreement: apiUrlWithParams(
    (rateAgreementId: number | string | undefined | null) =>
      `${RATE_AGREEMENT_URL_COMBINED}/${rateAgreementId}/AvailableBidPacks`
  ),
};

// CUT OFF TIMES
const CUT_OFF_TIME_URL = `CutOffTimes`;
export const cutOffTimeUrls = {
  base: applicationUrl({
    relativeUrl: `${RATE_AGREEMENT_URL}/${CUT_OFF_TIME_URL}`,
    relativeApiUrl: `${STATIC_NETWORK_URL}/${RATE_AGREEMENT_URL}/${CUT_OFF_TIME_URL}`,
  }),
  forRateAgreement: {
    uiPathFor: uiPathWithParams(
      (rateAgreementId: string | number) =>
        `${RATE_AGREEMENT_URL}/${rateAgreementId}/${CUT_OFF_TIME_URL}`
    ),
    searchParams: (searchParams: { rateAgreementName: string; carrierName: string }) =>
      `?rateAgreementName=${encodeURIComponent(
        searchParams.rateAgreementName
      )}&carrierName=${encodeURIComponent(searchParams.carrierName)}`,
    apiUrlForId: apiUrlWithParams(
      (rateAgreementId: string | undefined) =>
        `${STATIC_NETWORK_URL}/${RATE_AGREEMENT_URL}/${rateAgreementId}/${CUT_OFF_TIME_URL}`
    ),
  },
};

// ROUTES
const ROUTE_URL = "Routes";
// FTL
const FTL_ROUTES_URL = "FTLRoutes";
const FTL_URL = "FTL";
export const ftlRouteUrls = {
  base: applicationUrl({
    relativeUrl: FTL_ROUTES_URL,
    relativeApiUrl: `${ROUTE_URL}/${FTL_URL}`,
  }),
  detailsFor: uiPathWithParams((routeId: number | string) => `${FTL_ROUTES_URL}/${routeId}`),
  apiDetailsFor: apiUrlWithParams(
    (routeId: number | string) => `/${ROUTE_URL}/${FTL_URL}/${routeId}`
  ),
  allFtlRouteIdsFromFilter: asAbsoluteApiUrl(`${ROUTE_URL}/${FTL_URL}/AllFtlRouteIdsFromFilter`),
};

// PROPOSED FTL
const PROPOSED_FTL_ROUTE_URL = "ProposedFTLRoutes";
const PROPOSED_URL = "Proposed";
export const proposedFtlRouteUrls = {
  base: applicationUrl({
    relativeUrl: PROPOSED_FTL_ROUTE_URL,
    relativeApiUrl: `/${ROUTE_URL}/${FTL_URL}/${PROPOSED_URL}`,
  }),
  apiUrlForRouteWithId: apiUrlWithParams(
    (routeId: number) => `/${ROUTE_URL}/${FTL_URL}/${PROPOSED_URL}/${routeId}`
  ),
};

// PROJECTS
const PROJECTS_URL = "Projects";
export const projectUrls = {
  base: applicationUrl({ relativeUrl: PROJECTS_URL }),
  projectWithId: urlWithParams((id: string | number | undefined) => `/${PROJECTS_URL}/${id}`),
  projectFtlRouteApiUrl: apiUrlWithParams(
    (params: { projectId: number | undefined; ftlRouteId: number | undefined }) =>
      `${PROJECTS_URL}/${params.projectId}/FtlRoutes/${params.ftlRouteId}`
  ),
  projectFromSpdrs: asAbsoluteApiUrl(`/${PROJECTS_URL}/FromSPDRs`),
  projectFromPdsrs: asAbsoluteApiUrl(`/${PROJECTS_URL}/FromPDSRs`),
  nextLtlRouteForSpdr: apiUrlWithParams(
    (projectId: number | undefined) => `/${PROJECTS_URL}/${projectId}/NextLtlRoute`
  ),
  nextLtlRouteForPdsr: apiUrlWithParams(
    (projectId: number | undefined) => `/${PROJECTS_URL}/${projectId}/NextLtlRouteForPdsr`
  ),
};

export const projectStateTransitionApiUrls = {
  gotoNextProjectState: asAbsoluteApiUrl("/StateTransitions/GotoNextProjectState"),
  gotoNextRouteStateByProject: asAbsoluteApiUrl("/StateTransitions/GotoNextRouteStateByProject"),
};

// TRANSPORT NETWORK
const TRANSPORT_NETWORK_URL = "TransportNetwork";
// TT PROTECTION
const TT_PROTECTION_URL = "TTProtections";
const COMBINED_TT_PROTECTION_URL = `${TRANSPORT_NETWORK_URL}/${TT_PROTECTION_URL}`;
export const ttProtectionUrls = {
  base: applicationUrl({
    relativeUrl: TT_PROTECTION_URL,
    relativeApiUrl: `/${COMBINED_TT_PROTECTION_URL}`,
  }),
  addTTProtection: applicationUrl({
    relativeUrl: `/${TT_PROTECTION_URL}/Add`,
    relativeApiUrl: `/${COMBINED_TT_PROTECTION_URL}`,
  }),
  detailsFor: uiPathWithParams(
    (ttProtectionId: number | string | undefined) => `${TT_PROTECTION_URL}/${ttProtectionId}`
  ),
  apiDetailsFor: apiUrlWithParams(
    (ttProtectionId: number | string | undefined) =>
      `/${COMBINED_TT_PROTECTION_URL}/${ttProtectionId}`
  ),
  updateTTProtectionWithNewVersionApiUrl: apiUrlWithParams(
    (ttProtectionId: number | string | undefined) =>
      `/${COMBINED_TT_PROTECTION_URL}/${ttProtectionId}/SaveAsNewVersion`
  ),
  ttProtectionFromSpdrs: asAbsoluteApiUrl(`/${COMBINED_TT_PROTECTION_URL}/FromSPDRs`),
};

const TT_PROTECTION_FILTERS_URL = `${TRANSPORT_NETWORK_URL}/${TT_PROTECTION_URL}/Filters`;
export const ttProtectionFilterUrls = {
  ftlRoutes: asAbsoluteApiUrl(`/${TT_PROTECTION_FILTERS_URL}/FtlRoutes`),
  odcsAndCrossDocks: asAbsoluteApiUrl(`/${TT_PROTECTION_FILTERS_URL}/OdcsAndCrossDocks`),
  crossingCountries: asAbsoluteApiUrl(`/${TT_PROTECTION_FILTERS_URL}/CrossingCountries`),
  supplierCountries: asAbsoluteApiUrl(`/${TT_PROTECTION_FILTERS_URL}/SupplierCountries`),
  supplierRegions: asAbsoluteApiUrl(`/${TT_PROTECTION_FILTERS_URL}/SupplierRegions`),
  supplierPostcodeAreas: asAbsoluteApiUrl(`/${TT_PROTECTION_FILTERS_URL}/SupplierPostcodeAreas`),
  ieoPlants: asAbsoluteApiUrl(`/${TT_PROTECTION_FILTERS_URL}/IeoPlants`),
  suppliers: asAbsoluteApiUrl(`/${TT_PROTECTION_FILTERS_URL}/Suppliers`),
  affectedSprsByTtProtectionFilters: asAbsoluteApiUrl(`/${TT_PROTECTION_FILTERS_URL}/AffectedSPRs`),
  selectedFilterForTtProtection: apiUrlWithParams(
    (ttProtectionId: number | string | undefined) =>
      `/${TT_PROTECTION_FILTERS_URL}/${ttProtectionId}/SelectedFilters`
  ),
  plantsByPlantTypes: asAbsoluteApiUrl(`/${TT_PROTECTION_FILTERS_URL}/PlantsByPlantTypes`),
};

// SPDRs
const SPDR_URL = "SPDRs";
export const spdrUrls = {
  base: applicationUrl({ relativeUrl: SPDR_URL }),
  spdrWithId: urlWithParams((spdrId: number | string | undefined) => `${SPDR_URL}/${spdrId}`),
  addSpdr: applicationUrl({
    relativeUrl: `/${SPDR_URL}/Add`,
    relativeApiUrl: `/${SPDR_URL}`,
  }),
  expire: asAbsoluteApiUrl(`/${SPDR_URL}/Expire`),
  excludeFromScope: asAbsoluteApiUrl(`/${SPDR_URL}/ExcludeFromScope`),
  shipFrequencyApiUrl: apiUrlWithParams(
    (spdrId: number | undefined) => `/${SPDR_URL}/${spdrId}/ShipFrequency`
  ),
  overviewLastUpdated: asAbsoluteApiUrl(`/${SPDR_URL}/OverviewLastUpdated`),
  reports: asAbsoluteApiUrl(`${SPDR_URL}/Reports`),

  triggerCalculation: asAbsoluteApiUrl(`${SPDR_URL}/CalculationTrigger`),
  allSpdrIdsFromFilter: asAbsoluteApiUrl(`${SPDR_URL}/AllSpdrIdsFromFilter`),
};

// RETURN NETWORK / PDSRs
const RETURN_NETWORK_URL = "ReturnNetwork";
const PDSR_OVERVIEW_API_URL = "PDSROverview";
export const returnNetworkUrls = {
  pdsrOverview: applicationUrl({
    relativeUrl: RETURN_NETWORK_URL,
    relativeApiUrl: PDSR_OVERVIEW_API_URL,
  }),
  reportOverviewData: asAbsoluteApiUrl(`${PDSR_OVERVIEW_API_URL}/Report`),
  reportContainerData: asAbsoluteApiUrl(`${PDSR_OVERVIEW_API_URL}/ContainerDataReport`),
  reportForecastData: asAbsoluteApiUrl(`${PDSR_OVERVIEW_API_URL}/ForecastDataReport`),
  editPdsr: uiPathWithParams(
    (pdsrId: number | string | undefined) => `/${RETURN_NETWORK_URL}/${pdsrId}`
  ),
};

const PDSR_URL = "PDSRs";
const createUrlForPdsrWithId = (pdsrId: string | undefined) => `/${PDSR_URL}/${pdsrId}`;
export const pdsrUrls = {
  base: applicationUrl({ relativeUrl: `/${PDSR_URL}` }),
  upload: asAbsoluteApiUrl(`/${PDSR_URL}/UploadCsv`),
  pdsrWithId: apiUrlWithParams(createUrlForPdsrWithId),
  containersForPdsrWithId: apiUrlWithParams(
    (pdsrId: string | undefined) => `${createUrlForPdsrWithId(pdsrId)}/Containers`
  ),
  overviewLastUpdated: asAbsoluteApiUrl(`/${PDSR_URL}/OverviewLastUpdated`),
  triggerCalculation: asAbsoluteApiUrl(`${PDSR_URL}/CalculationTrigger`),
  allPdsrIdsFromFilter: asAbsoluteApiUrl(`${PDSR_URL}/AllPdsrIdsFromFilter`),
};

// Other
export const whoAmIUrl = applicationUrl({
  relativeUrl: "/whoami",
  relativeApiUrl: "/User/WhoAmI",
});
